import { render, staticRenderFns } from "./GroupItem.vue?vue&type=template&id=2f19ff9e&scoped=true&"
import script from "./GroupItem.ts?vue&type=script&lang=ts&"
export * from "./GroupItem.ts?vue&type=script&lang=ts&"
import style0 from "./GroupItem.scss?vue&type=style&index=0&id=2f19ff9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f19ff9e",
  null
  
)

export default component.exports